// /* Móvil: mueve el grupo de iconos (audio, compartir, wishlist) a la misma fila del select de variantes */
// (() => {
//   if (window.__pdpIconsMove) return;
//   window.__pdpIconsMove = true;

//   const mq = window.matchMedia('(max-width: 749px)');
//   let icons = null;
//   let placeholder = null;

//   const move = () => {
//     icons =
//       icons ||
//       document
//         .querySelector('#toki-shopify-integration-block-wishlist-button-root')
//         ?.closest('.group-block-content');

//     // Fila que contiene el select de variantes
//     const row = document.querySelector('variant-picker')?.closest('.group-block-content');
//     if (!icons || !row || icons.contains(row)) return;

//     if (mq.matches) {
//       if (!placeholder) {
//         placeholder = document.createComment('pdp-icons');
//         icons.before(placeholder);
//       }
//       if (icons.parentElement !== row) row.append(icons);
//       icons.classList.add('pdp-icons--moved');
//       row.classList.add('pdp-picker-row');
//     } else if (placeholder) {
//       placeholder.replaceWith(icons);
//       placeholder = null;
//       icons.classList.remove('pdp-icons--moved');
//       row.classList.remove('pdp-picker-row');
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', move);
//   } else {
//     move();
//   }
//   setTimeout(move, 800);
//   setTimeout(move, 2000);
//   mq.addEventListener('change', move);

//   // Al cambiar de variante el tema puede redibujar el bloque: lo volvemos a colocar
//   document.addEventListener('change', (e) => {
//     if (e.target.closest('variant-picker')) {
//       setTimeout(move, 300);
//       setTimeout(move, 1000);
//     }
//   });
// })();




/* PDP version-b (móvil):
   1) Botones (audio, compartir, wishlist) flotando sobre la imagen, a la derecha.
      NO se mueve el elemento <audio-player-...> (eso lo reinicializa y rompe el audio);
      solo se mueven su botón y su panel, que conservan sus eventos.
   2) Contador de cantidad al lado del select de variantes (ml), enlazado al formulario. */
(() => {
  if (window.__pdpIconsMove) return;
  window.__pdpIconsMove = true;

  const mq = window.matchMedia('(max-width: 749px)');

  /* ===================== 1) ICONOS SOBRE LA IMAGEN ===================== */
  let source = null;
  let floating = null;
  let moved = [];

  const findHost = () =>
    document.querySelector('.product-information__media media-gallery') ||
    document.querySelector('media-gallery') ||
    document.querySelector('.product-media')?.closest('.product-information__media') ||
    document.querySelector('.product-information__media');

  const freeAudioPanels = () => {
    document.querySelectorAll('[class^="ai-audio-player-container-"]').forEach((panel) => {
      if (panel.parentElement !== document.body) document.body.append(panel);
    });
  };

  const collectNodes = () => {
    const nodes = [];
    const trigger = source.querySelector('[class^="ai-audio-player-trigger-"]');
    if (trigger) nodes.push(trigger);
    source.querySelectorAll(':scope > .shopify-block').forEach((b) => nodes.push(b));
    return nodes;
  };

  const iconsToFloating = () => {
    const host = findHost();
    if (!host) return;

    if (!floating) {
      floating = document.createElement('div');
      floating.className = 'pdp-floating-icons';
      ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'mousedown'].forEach((type) =>
        floating.addEventListener(type, (e) => e.stopPropagation())
      );
    }
    if (floating.parentElement !== host) host.append(floating);
    host.classList.add('pdp-media-host');

    if (!moved.length) {
      collectNodes().forEach((node) => {
        const placeholder = document.createComment('pdp-icon');
        node.before(placeholder);
        floating.append(node);
        moved.push({ node, placeholder });
      });
    }
    source.classList.add('pdp-icons-source');
  };

  const iconsRestore = () => {
    moved.forEach(({ node, placeholder }) => placeholder.replaceWith(node));
    moved = [];
    floating?.remove();
    source?.classList.remove('pdp-icons-source');
  };

  const runIcons = () => {
    source =
      source ||
      document
        .querySelector('#toki-shopify-integration-block-wishlist-button-root')
        ?.closest('.group-block-content');
    if (!source) return;

    freeAudioPanels();
    if (mq.matches) iconsToFloating();
    else iconsRestore();
  };

  /* ===================== 2) CONTADOR AL LADO DEL SELECT ===================== */
  let qtyWrap = null;
  let qtyPlaceholder = null;

  // Fuera del formulario del tema, el botón "−" no se reactiva solo: lo controlamos aquí
  const watchQtyButtons = (wrap) => {
    if (wrap.__pdpQtyWatch) return;
    const input = wrap.querySelector('input[name="quantity"]');
    const minus = wrap.querySelector('button[name="minus"]');
    const plus = wrap.querySelector('button[name="plus"]');
    if (!input || !minus) return;
    wrap.__pdpQtyWatch = true;

    const update = () => {
      const val = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 1;
      const max = parseInt(input.max || input.dataset.stock, 10) || Infinity;

      const minusOff = val <= min;
      if (minus.disabled !== minusOff) minus.disabled = minusOff;

      if (plus) {
        const plusOff = val >= max;
        if (plus.disabled !== plusOff) plus.disabled = plusOff;
      }
    };

    const later = () => {
      requestAnimationFrame(update);
      setTimeout(update, 60);
    };

    wrap.addEventListener('click', later);
    input.addEventListener('input', later);
    input.addEventListener('change', later);
    input.addEventListener('blur', later);

    // Si el tema vuelve a deshabilitar los botones, lo corregimos
    new MutationObserver(later).observe(wrap, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'value'],
    });

    update();
  };

  const runQty = () => {
    const row = document.querySelector('variant-picker')?.closest('.group-block-content');
    const picker = row?.querySelector(':scope > variant-picker');

    if (mq.matches) {
      // .sbb-qty-out lo crea el script de la barra fija (dentro del formulario)
      qtyWrap = qtyWrap || document.querySelector('.sbb-qty-out');
      if (!qtyWrap || !row || !picker) return;

      if (qtyWrap.parentElement !== row) {
        // Mantener la cantidad enlazada a su formulario aunque salga de él
        const form = qtyWrap.closest('form');
        if (form?.id) {
          qtyWrap.querySelectorAll('input, select, textarea, button').forEach((el) => {
            el.setAttribute('form', form.id);
          });
        }
        if (!qtyPlaceholder) {
          qtyPlaceholder = document.createComment('pdp-qty');
          qtyWrap.before(qtyPlaceholder);
        }
        picker.after(qtyWrap);
      }
      qtyWrap.classList.add('pdp-qty--moved');
      row.classList.add('pdp-picker-row');
      watchQtyButtons(qtyWrap);
    } else if (qtyWrap && qtyPlaceholder) {
      qtyPlaceholder.replaceWith(qtyWrap);
      qtyPlaceholder = null;
      qtyWrap.classList.remove('pdp-qty--moved');
      row?.classList.remove('pdp-picker-row');
    }
  };

  /* ===================== 3) BUY NOW DEBAJO DEL SELECT + CONTADOR ===================== */
  // No se mueve el elemento <buy-now-button-...> (registraría su clic dos veces);
  // solo su botón y su mensaje de error, que conservan sus eventos.
  let buyNowHost = null;
  let buyNowSlot = null;
  let buyNowMoved = [];

  const getPickerBlock = () =>
    document.querySelector('variant-picker')?.closest('.group-block-content')?.closest('.group-block');

  const runBuyNow = () => {
    buyNowHost = buyNowHost || document.querySelector('[class^="ai-buy-now-container-"]');
    if (!buyNowHost) return;

    // Que Buy Now use la cantidad del contador aunque esté fuera del formulario
    if (!buyNowHost.__pdpQtyPatched) {
      buyNowHost.__pdpQtyPatched = true;
      buyNowHost.getSelectedQuantity = () => {
        const input =
          document.querySelector('.pdp-qty--moved input[name="quantity"]') ||
          document.querySelector('form[action*="/cart/add"] [name="quantity"]') ||
          document.querySelector('input[name="quantity"]');
        return Math.max(1, parseInt(input?.value, 10) || 1);
      };
    }

    const pickerBlock = getPickerBlock();

    if (mq.matches) {
      if (!pickerBlock) return;
      if (!buyNowSlot) {
        buyNowSlot = document.createElement('div');
        buyNowSlot.className = 'pdp-buynow-slot';
      }
      if (pickerBlock.nextElementSibling !== buyNowSlot) pickerBlock.after(buyNowSlot);

      if (!buyNowMoved.length) {
        buyNowHost
          .querySelectorAll(':scope > [data-buy-now-button], :scope > [data-error-message]')
          .forEach((node) => {
            const placeholder = document.createComment('pdp-buynow');
            node.before(placeholder);
            buyNowSlot.append(node);
            buyNowMoved.push({ node, placeholder });
          });
      }
      buyNowHost.classList.add('pdp-buynow-source');
    } else if (buyNowMoved.length) {
      buyNowMoved.forEach(({ node, placeholder }) => placeholder.replaceWith(node));
      buyNowMoved = [];
      buyNowSlot?.remove();
      buyNowHost.classList.remove('pdp-buynow-source');
    }
  };

  /* ===================== 4) ICONOS DE CONFIANZA DEBAJO DE BUY NOW ===================== */
  let trust = null;
  let trustSection = null;
  let trustPlaceholder = null;

  const runTrust = () => {
    trust =
      trust ||
      document
        .querySelector('a[href*="/pages/shipping-policy"] img.icon-block__media')
        ?.closest('.section-content-wrapper');
    if (!trust) return;
    trustSection = trustSection || trust.closest('.shopify-section');

    // Va después de Buy Now (o del select + contador si Buy Now no está)
    const anchor =
      (buyNowSlot && buyNowSlot.isConnected && buyNowSlot) || getPickerBlock();

    if (mq.matches) {
      if (!anchor) return;
      if (!trustPlaceholder) {
        trustPlaceholder = document.createComment('pdp-trust');
        trust.before(trustPlaceholder);
      }
      if (anchor.nextElementSibling !== trust) anchor.after(trust);
      trust.classList.add('pdp-trust--moved');
      trustSection?.classList.add('pdp-trust-source');
    } else if (trustPlaceholder) {
      trustPlaceholder.replaceWith(trust);
      trustPlaceholder = null;
      trust.classList.remove('pdp-trust--moved');
      trustSection?.classList.remove('pdp-trust-source');
    }
  };

  /* ===================== EJECUCIÓN ===================== */
  const run = () => {
    runIcons();
    runQty();
    runBuyNow();
    runTrust();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // El contador lo crea otro script a los 0 / 500 / 1500 / 3000 ms
  [300, 800, 1600, 2000, 3200].forEach((t) => setTimeout(run, t));
  mq.addEventListener('change', run);

  // Si al cambiar de variante el tema redibuja algo, lo volvemos a colocar
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-picker')) {
      setTimeout(run, 300);
      setTimeout(run, 1000);
    }
  });
})();